import React, { Suspense } from 'react';

import { Loader } from '@trackman/web-shared-components';

type Props = {
  modelScene: string;
};

const Spline = React.lazy(() => import('@splinetool/react-spline'));

export const ThreeDModel = ({ modelScene }: Props) => {
  return (
    <Suspense
      fallback={
        <div className='loader-wrapper'>
          <Loader size='large' />
        </div>
      }
    >
      <Spline scene={modelScene} />
    </Suspense>
  );
};

export default ThreeDModel;
